import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

const myCustomTheme = {
    dark: false,
    colors: {
        primary: '#00265E',
        secondary: '#FA6A01',
        accent: '#FA6A01',
        background: '#ffffff',
        surface: '#ffffff',
        'on-primary': '#ffffff',
        'on-secondary': '#ffffff',
        'on-surface': '#1a1a2e',
        error: '#d32f2f',
        info: '#0288d1',
        success: '#388e3c',
        warning: '#ed6c02',
    }
}

export default createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: 'myCustomTheme',
        themes: {
            myCustomTheme
        }
    },
    defaults: {
        VBtn: {
            rounded: 'lg',
            fontWeight: 600,
        },
        VCard: {
            rounded: 'xl',
            elevation: 2,
        }
    }
})